import React, { useMemo, useState } from "react";

// Stylised SVG world map. Malaysia is the central hub connected to Canada, UK, Pakistan, India.
const NODES = {
  malaysia: { x: 760, y: 300, label: "Malaysia", sub: "Headquarters", hub: true },
  canada: { x: 220, y: 170, label: "Canada", sub: "Regional Service Network" },
  uk: { x: 470, y: 150, label: "United Kingdom", sub: "Regional Service Network" },
  pakistan: { x: 640, y: 230, label: "Pakistan", sub: "Representative Network" },
  india: { x: 690, y: 260, label: "India", sub: "Representative Network" },
};

export default function WorldMap() {
  const [active, setActive] = useState("malaysia");
  const hub = NODES.malaysia;
  const spokes = useMemo(() => Object.entries(NODES).filter(([k]) => k !== "malaysia"), []);
  const allNodes = useMemo(() => Object.entries(NODES), []);

  return (
    <div data-testid="interactive-world-map" className="relative rounded-2xl overflow-hidden bg-navy border border-white/10">
      <div className="absolute inset-0 geo-overlay opacity-40" />
      <svg viewBox="0 0 1000 480" className="w-full h-auto relative">
        <defs>
          <radialGradient id="glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#D4AF37" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#D4AF37" stopOpacity="0" />
          </radialGradient>
        </defs>
        {/* Simplified continents */}
        <g fill="#1E3E62" opacity="0.55">
          <path d="M100 120 Q180 90 280 120 L320 200 Q280 260 200 250 L140 230 Q90 190 100 120Z" />
          <path d="M250 280 L330 270 L360 400 L300 440 L260 360Z" />
          <path d="M440 110 Q500 100 540 130 L520 200 Q470 210 450 180Z" />
          <path d="M540 220 L620 200 L660 330 L560 350 L540 280Z" />
          <path d="M600 150 Q720 130 820 170 L880 260 Q820 340 720 330 L640 280 Q600 220 600 150Z" />
          <path d="M780 340 Q860 330 900 370 L880 430 Q820 440 790 400Z" />
        </g>

        {/* Connection lines from Malaysia hub */}
        {spokes.map(([k, n]) => (
          <line key={k} x1={hub.x} y1={hub.y} x2={n.x} y2={n.y}
            stroke={active === k ? "#D4AF37" : "#D4AF37"} strokeOpacity={active === k ? 0.9 : 0.35}
            strokeWidth={active === k ? 2.5 : 1.5} className="map-line" />
        ))}

        {/* Nodes */}
        {allNodes.map(([k, n]) => (
          <g key={k} data-testid={`world-map-node-${k}`} onMouseEnter={() => setActive(k)} onClick={() => setActive(k)} className="cursor-pointer">
            {n.hub && <circle cx={n.x} cy={n.y} r="42" fill="url(#glow)" />}
            <circle cx={n.x} cy={n.y} r={n.hub ? 9 : 6} fill={n.hub ? "#D4AF37" : "#147B4E"} className={active === k ? "map-dot" : ""} />
            <circle cx={n.x} cy={n.y} r={n.hub ? 9 : 6} fill="none" stroke="#fff" strokeWidth="1.5" strokeOpacity="0.8" />
            <text x={n.x} y={n.y - 16} textAnchor="middle" fill="#fff" fontSize="15" fontWeight="700" fontFamily="Plus Jakarta Sans">{n.label}</text>
          </g>
        ))}
      </svg>

      <div data-testid="world-map-info" className="absolute bottom-4 left-4 right-4 bg-white/95 rounded-xl p-4 max-w-md">
        <div className="text-xs font-bold tracking-wide text-emerald-brand uppercase">{NODES[active].label}</div>
        <div className="text-navy font-bold">{NODES[active].sub}</div>
        <p className="text-sm text-slate-600 mt-1">
          {active === "malaysia" && "Labuan setup, Malaysian incorporation, Asian market entry and global client coordination. Contact us to know more."}
          {active === "canada" && "Business purchase, market entry, incorporation and licensed immigration partner coordination. Calgary, Alberta · +1 403 671 4469."}
          {active === "uk" && "Company formation, market entry and business support. Contact us to know more."}
          {active === "pakistan" && "Client onboarding, documentation support and regional business development. Contact us to know more."}
          {active === "india" && "Client onboarding, business partnerships and regional development. Contact us to know more."}
        </p>
      </div>
    </div>
  );
}
